import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useCustomerAttributeGroupId } from './useCustomerAttributeGroupId'

const document = graphql(`
  mutation CustomerAttributeListPage_CreateCustomerAttributeBulk(
    $customerAttributeGroupId: ID!
    $input: [CustomerAttributeInput!]!
  ) {
    createCustomerAttributeBulk(
      customerAttributeGroupId: $customerAttributeGroupId
      input: $input
    ) {
      customerAttributes {
        id
      }
    }
  }
`)

export const useCreateCustomerAttributesMutation = (
  options: Omit<
    UseMutationOptions<
      ResultOf<typeof document>,
      unknown,
      VariablesOf<typeof document>['input'],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const customerAttributeGroupId = useCustomerAttributeGroupId()

  return useMutation({
    mutationFn: (input) =>
      graphQLRequest({
        document,
        variables: { customerAttributeGroupId, input },
      }),
    ...options,
  })
}
